export enum RoutesEnum {
  EMPTY = '',
  WILDCARD = '**',
  LOGIN = 'login',
  MODIFY_USER = 'modify-user',
  ID_PARAMETER = '/:id'
}
